module.exports = __webpack_public_path__ + "static/img/nothing.258701d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nothing.png
// module id = 199
// module chunks = 1